import React from 'react';
import SectionHeading from '../shared/SectionHeading';
import ServiceCard from '../shared/ServiceCard';
import PrimaryButton from '../shared/PrimaryButton';
import services from '../../data/services';

const ServicesGrid = () => (
  <section className="section section-surface">
    <div className="container">
      <SectionHeading
        eyebrow="Core Services"
        title="Heating and cooling work focused on comfort, reliability, and clear next steps."
        description="We keep the offering simple: repairs when possible, replacement guidance when needed, and maintenance that helps your system stay ready for the season."
      />
      <div className="responsive-grid responsive-grid-3">
        {services.map((service) => (
          <ServiceCard key={service.title} {...service} />
        ))}
      </div>
      <div className="section-actions">
        <PrimaryButton to="/service">View Full Service Details</PrimaryButton>
      </div>
    </div>
  </section>
);

export default ServicesGrid;
